import ImportModal from './link-import-modal'

class Import {
    Vue;
    _instance;

    storage = {}

    constructor(Vue) {
        this.Vue = Vue
    }

    get instance() {
        if (!this._instance) {
            this._instance = this.newInstance()
        }
        return this._instance
    }

    newInstance() {
        const instance = new this.Vue(ImportModal).$mount()
        document.body.appendChild(instance.$el)
        return instance
    }

    async show(importCode, context) {
		const importId = await this.getImportId(importCode, context);
		if (!importId) {
			return
		}
		const tabOption = {
			id: `${context.pageTabData.id}#import`,
			title: `${context.pageTabData.title}-数据导入`,
			path: `/${context.$linkModule}/crm/public_data_management/public_data_manage/step2.vue`,
			param: {id: importId},
			data: {fromComment: true}
		}
		await context.$nav.openTab(tabOption, true);
		// return new Promise((rs) => {
		//     this.instance.importCode = importCode;
		//     this.instance.show = true;
		//     this.instance.onConfirm = rs;
		//     this.instance.$http = context.$http
		// 	this.instance.context = context
		// })
    }

    onConfirm(obj) {

    }

	/**
	 * desc 通过编码code查询模版，选择并进入下一步
	 * @author 姚润发
	 * @date 2020/12/01
	 * @params
	 */
	async getImportId(importCode, context) {
		try {
			const data = await context.$http.post(`/action/${LinkVue.prefixUrl}/publicdataimport/queryByExamplePage`, {
				pageFlag: false,
				oauth: 'ALL',
				isOrg: 'Y',
				filtersRaw: [
					{
						id: 'encoded',
						property: 'encoded',
						value: `[${importCode}]`,
						operator: 'IN'
					},
				],
			}, true);
			if (data.success) {
				if (data.rows[0]) {
					return data.rows[0].id;
				} else {
					context.$message.warning(LinkVue.$t('LinkAutoTable.cannotFindImportTemplate'));
				}
			} else {
				context.$nav.error(LinkVue.$t('LinkAutoTable.searchImportConfigFail') + ':' + data.result);
			}
		} catch (e) {
			context.$nav.error(LinkVue.$t('LinkAutoTable.searchImportConfigFail') + ':' + e);
		}
		return null
	}

}

export default Import
